import { render } from "./StatisticRevenue.vue?vue&type=template&id=259ef69e&scoped=true"
import script from "./StatisticRevenue.vue?vue&type=script&lang=js"
export * from "./StatisticRevenue.vue?vue&type=script&lang=js"

import "./StatisticRevenue.vue?vue&type=style&index=0&id=259ef69e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259ef69e"]])

export default __exports__